import React, { useState, useCallback } from 'react';
import { getCookie, setCookie, eraseCookie } from './cookies';

export const UserAuthContext = React.createContext<any>(undefined);
export const AuthContext = UserAuthContext;

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authenticationState, setAuthState] = useState(getCookie('Authorization') || '');
  const [shouldBootstrapUser, setShouldBootstrapUser] = useState(true);

  const clearAuthenticationState = useCallback(() => {
    eraseCookie('Authorization');
    setAuthState('');
    setShouldBootstrapUser(true);
  }, []);

  const setAuthenticationStateJWT = useCallback((auth: string) => {
    if (!auth) {
      clearAuthenticationState();
      return;
    }
    setCookie('Authorization', auth); // Session cookie (expires on browser close)
    setAuthState(auth);
  }, [clearAuthenticationState]);

  const setAuthenticationStateLogin = useCallback((auth: string) => {
    if (!auth) {
      clearAuthenticationState();
      return;
    }
    setShouldBootstrapUser(false);
    setCookie('Authorization', auth); // Session cookie (expires on browser close)
    setAuthState(auth);
  }, [clearAuthenticationState]);

  const value = React.useMemo(
    () => ({
      authenticationState,
      shouldBootstrapUser,
      setAuthenticationStateJWT,
      setAuthenticationStateLogin
    }),
    [authenticationState, shouldBootstrapUser, setAuthenticationStateJWT, setAuthenticationStateLogin]
  );

  return <UserAuthContext.Provider value={value}>{children}</UserAuthContext.Provider>;
};
